(function () {
  const COOKIE_CHOICE = 'region_redirect_choice';
  const COOKIE_CHECKED = 'is_region_redirect_checked';
  const COOKIE_DAYS = 8;

  const USA_STORE_URL = 'https://grell-audio-usa.myshopify.com/';
  const EU_LOCAL_URL = 'https://de.grellaudio.com/';
  const USA_STORE_HOST_MATCH = 'grell-audio-usa.myshopify.com';
  const EU_STORE_HOST_MATCH = 'grell-audio-germany.myshopify.com';

  // EU/EEA country codes — sourced from theme settings (Customizer > Geo Location > EU region country codes)
  const EU_REGION_CODES = new Set(
    (typeof window.__euRegionCodes === 'string' ? window.__euRegionCodes : '')
      .split(',')
      .map((c) => c.trim().toUpperCase())
      .filter(Boolean)
  );

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1];
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
  }

  function extractSuggestionCountry(suggestionsResponse) {
    const candidates = [];
    if (suggestionsResponse && typeof suggestionsResponse === 'object') {
      if (Array.isArray(suggestionsResponse.suggestions)) candidates.push(...suggestionsResponse.suggestions);
      if (Array.isArray(suggestionsResponse.browsing_context_suggestions)) candidates.push(...suggestionsResponse.browsing_context_suggestions);
      if (Array.isArray(suggestionsResponse.country_suggestions)) candidates.push(...suggestionsResponse.country_suggestions);
    }

    for (const item of candidates) {
      if (!item || typeof item !== 'object') continue;
      const countryCode =
        item.country_code || item.countryCode || item.country || item.country_iso_code || item.countryIsoCode;
      const countryName =
        item.country_name || item.countryName || item.country_label || item.countryLabel || item.name;
      if (countryCode) return { countryCode: String(countryCode).toUpperCase(), countryName: countryName || '' };
    }

    return null;
  }

  function getVisitorCountryFromShopifySuggestions() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = `${root}browsing_context_suggestions.json`;
    return fetch(url, { credentials: 'same-origin' })
      .then((res) => {
        if (!res.ok) throw new Error(`Shopify suggestions fetch failed: ${res.status}`);
        return res.json();
      })
      .then((data) => extractSuggestionCountry(data));
  }

  function getVisitorCountryFromGeoJs() {
    return fetch('https://get.geojs.io/v1/ip/geo.json')
      .then((res) => res.json())
      .then((data) => {
        if (!data || !data.country_code) return null;
        return {
          countryCode: String(data.country_code).toUpperCase(),
          countryName: data.country || '',
        };
      })
      .catch(() => null);
  }

  function getVisitorCountry() {
    // Primary: Shopify browsing context suggestions (IP-based)
    return getVisitorCountryFromShopifySuggestions()
      .then((visitor) => visitor || getVisitorCountryFromGeoJs())
      .catch(() => getVisitorCountryFromGeoJs());
  }

  function getStoreContext() {
    const host = String(window.location && window.location.hostname ? window.location.hostname : '').toLowerCase();
    const isEuStore = host.includes(EU_STORE_HOST_MATCH);
    const isUsaStore = host.includes(USA_STORE_HOST_MATCH);
    return { host, isEuStore, isUsaStore };
  }

  function shouldShowAndTarget(countryCode) {
    const code = String(countryCode || '').toUpperCase();
    const isEuVisitor = EU_REGION_CODES.has(code);
    const { isEuStore, isUsaStore } = getStoreContext();

    // EU Store rules:
    // - EU visitor: do not show
    // - non-EU visitor: show, target Global/USA store
    if (isEuStore) {
      if (isEuVisitor) return { show: false };
      return { show: true, targetUrl: USA_STORE_URL };
    }

    // Global/USA Store rules:
    // - EU visitor: show, target EU store
    // - non-EU visitor: do not show
    // If store host can't be determined, treat it as Global/USA store behavior.
    if (isUsaStore || true) {
      if (isEuVisitor) return { show: true, targetUrl: EU_LOCAL_URL };
      return { show: false };
    }
  }

  function dispatchDone() {
    document.dispatchEvent(new CustomEvent('regionLocationDone'));
  }

  if (getCookie(COOKIE_CHECKED)) { dispatchDone(); return; }
  if (getCookie(COOKIE_CHOICE)) return;

  getVisitorCountry().then((visitor) => {
    if (!visitor || !visitor.countryCode) { dispatchDone(); return; }

    const decision = shouldShowAndTarget(visitor.countryCode);
    if (!decision || !decision.show || !decision.targetUrl) { dispatchDone(); return; }

    const modal = document.getElementById('regionLocationModal');
    const text = document.getElementById('regionLocationModalText');
    const accept = document.getElementById('regionLocationModalAccept');
    const decline = document.getElementById('regionLocationModalDecline');
    const closeBtn = document.getElementById('regionLocationModalClose');

    if (!modal || !text || !accept || !decline || !closeBtn) return;

    // Only mark "checked" when we are actually going to show it.
    setCookie(COOKIE_CHECKED, 'true', COOKIE_DAYS);

    const countryLabel = visitor.countryName || visitor.countryCode;
    text.innerHTML = `
      You are browsing from the EU. For better pricing and delivery options, please visit our EU store.
    `;

    setTimeout(() => {
      modal.style.display = 'flex';
    }, 5000);

    function closeModal(choice = 'declined') {
      setCookie(COOKIE_CHOICE, choice, COOKIE_DAYS);
      modal.style.display = 'none';
      document.dispatchEvent(new CustomEvent('regionLocationDone', { detail: { choice } }));
    }

    accept.onclick = () => {
      closeModal('accepted');
      window.location.assign(decision.targetUrl);
    };

    decline.onclick = () => {
      closeModal('declined');
    };

    closeBtn.onclick = () => closeModal('declined');
  });
})();

